import { action } from "@ember/object"
import Component from "@glimmer/component"
import { handleError } from "cc-frontend/error-handling"
import type { NameAndMoreSig } from "../course/create-edit/name-and-more"
import styles from "./edit-course.module.css"

export interface EditCourseModalComponentSignature {
  Args: {
    model: NameAndMoreSig["Args"]
    order: number
    closeModal: () => void
  }
}

export default class EditCourseModalComponent extends Component<EditCourseModalComponentSignature> {
  readonly styles = styles

  @action close() {
    if (this.args.model.course.attributes.title) {
      this.args.closeModal?.()
    } else {
      window
        .swal({
          title: "You need to give this a name.",
          type: "error",
          showCancelButton: false,
        })
        .catch((error) => {
          if (error instanceof Error) handleError(error)
        })
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Modals::EditCourse": typeof EditCourseModalComponent
  }
}
